export default __webpack_public_path__ + "static/media/pen.d6dea77e.svg";